import i18n from '@/locale/i18n'
import axios from '@/axios'

const setItem = (name, data) => {
  window.sessionStorage.setItem(name, data)
}

const getItem = (name, data) => {
  return window.sessionStorage.getItem(name)
}

const state = {
  cmhk: true,
  home_walk_share_link: `${location.origin}${location.pathname}/#/xingshan/homeWalk?hideNavigationBar=true`,
  home_sign_share_link: `${location.origin}${location.pathname}/#/xingshan/homeSign?hideNavigationBar=true`,
  home_confirm_share_link: `${location.origin}${location.pathname}/#/xingshan/homeConfirm?hideNavigationBar=true`,
  home_share_link: `${location.origin}${location.pathname}/#/xingshan/home?hideNavigationBar=true`,
  walk_share_link: `${location.origin}${location.pathname}/#/xingshan/walk?hideNavigationBar=true`,
  inter_share_link: `${location.origin}${location.pathname}/#/xingshan/inter?hideNavigationBar=true`,
  userId: getItem('xingshan_20181101_user_id') || '',
  phone: getItem('xingshan_20181101_register_phone') || '',
  email: getItem('xingshan_20181101_register_email') || '',
  lastName: getItem('xingshan_20181101_register_last_name') || '',
  firstName: getItem('xingshan_20181101_register_first_name') || '',
  routeList: [],
  routeValue: getItem('xingshan_20181101_register_route_value') || 0,
  routeName: getItem('xingshan_20181101_register_route_name') || '',
  multi: 0,
  personNumList: i18n.t('xingshan.sign.personNumList'),
  personNum: getItem('xingshan_20181101_register_person_num') || 0,
  // 报名确认
  emergencyLastName: getItem('xingshan_20181101_confirm_last_name') || '',
  emergencyFirstName: getItem('xingshan_20181101_confirm_first_name') || '',
  emergencyPhone: getItem('xingshan_20181101_confirm_emergency_phone') || '',
  extraList: JSON.parse(getItem('xingshan_20181101_confirm_extra_list')) || [],
  extraNum: getItem('xingshan_20181101_confirm_extra_num') || 0,
  extraPersonLimit: getItem('xingshan_20181101_confirm_extra_num_limit') || 3,
  agreePhoto: Boolean(getItem('xingshan_20181101_argee_photo')) || false,
  // 签到
  captainPhone: getItem('xingshan_20181101_captain_phone') || '',
  signTime: getItem('xingshan_20181101_sign_time') || '',
  // 上传信息
  upload_userName: '',
  upload_title: '',
  // 查询照片
  photoInfo: {
    title: '',
    photoLink: ''
  },
  photoVoteds:[]
}

state.multi = state.personNum > 0 ? 1 : 0

const getters = {}

const actions = {}

const mutations = {
  changeMulti (state) {
    state.multi = state.multi ? 0 : 1
  },
  changeRouteValue (state, data) {
    state.routeValue = data
    setItem('xingshan_20181101_register_route_value', data)
  },
  updateRouteList (state, data = []) {
    state.routeList = data
  },
  changeLastName (state, data) {
    state.lastName = data
    setItem('xingshan_20181101_register_last_name', data)
  },
  changeFirstName (state, data) {
    state.firstName = data
    setItem('xingshan_20181101_register_first_name', data)
  },
  changeRouteName (state, data) {
    state.routeName = data
    setItem('xingshan_20181101_register_route_name', data)
  },
  changePersonNum (state, data) {
    state.personNum = data
    setItem('xingshan_20181101_register_person_num', data)
  },
  changePhone (state, data) {
    state.phone = data
    setItem('xingshan_20181101_register_phone', data)
  },
  changeEmail (state, data) {
    state.email = data
    setItem('xingshan_20181101_register_email', data)
  },
  changeCmhk (state, data) {
    state.cmhk = data
  },
  changeEmergencyPhone (state, data) {
    state.emergencyPhone = data
    setItem('xingshan_20181101_confirm_emergency_phone', data)
  },
  changeEmergencyLastName (state, data) {
    state.emergencyLastName = data
    setItem('xingshan_20181101_confirm_last_name', data)
  },
  changeEmergencyFirstName (state, data) {
    state.emergencyFirstName = data
    setItem('xingshan_20181101_confirm_first_name', data)
  },
  changeEmergencyExtraNum (state, data) {
    state.extraNum = data
    setItem('xingshan_20181101_confirm_extra_num', data)
  },
  changeEmergencyExtraList (state, data) {
    state.extraList = data
    setItem('xingshan_20181101_confirm_extra_list', JSON.stringify(data))
  },
  changeEmergencyExtraNumLimit (state, data) {
    state.extraPersonLimit = data
    setItem('xingshan_20181101_confirm_extra_num_limit', data)
  },
  changeAgreePhoto (state, data) {
    state.agreePhoto = data
    setItem('xingshan_20181101_argee_photo', data)
  },
  changeUserId (state, data) {
    state.userId = data
    setItem('xingshan_20181101_user_id', data)
  },
  changeUploadUserName (state, data) {
    state.upload_userName = data
  },
  changeUploadTitle (state, data) {
    state.upload_title = data
  },
  changeSignTime (state, data) {
    state.signTime = data
    setItem('xingshan_20181101_sign_time', data)
  },
  changeCaptainPhone (state, data) {
    state.captainPhone = data
    setItem('xingshan_20181101_captain_phone', data)
  },
  changePhotoInfo (state, data) {
    state.photoInfo = data
  },
  changePhotoVoteds (state, data) {
    state.photoVoteds = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/xingshan/index.js